<template>
  <div>
    <div class="grid-row">
      <div class=" titulo-grid">
        {{ titulo }}
      </div>
    </div>

    <div class="grid-row">
      <div class=" titulo">
        Aging dias
      </div>
      <div class="">
        {{ item.aging_dias_formatado }}
      </div>
      <div class=" titulo">
        Aging dias úteis
      </div>
      <div class="">
        {{ item.aging_dias_uteis_formatado }}
      </div>
    </div>

    <div class="grid-row">
      <div class=" titulo">
        Aging horas
      </div>
      <div class="">
        {{ item.aging_minutos_formatado }}
      </div>
      <div class=" titulo">
        Aging horas úteis
      </div>
      <div class=""></div>
    </div>
  </div>

</template>

<script>
export default {
  name: "AgingComponent",
  props: {
    item: {
      type: Object,
      required: true
    },
    titulo: {
      type: String,
      required: true
    }
  }
}
</script>